<template>
	<v-container grid-list-xl>
		<v-layout row wrap>		
          <v-flex xs3>
            <v-text-field append-icon="search" label="Search" solo single-line v-model="search"></v-text-field>
          </v-flex>      
			<v-flex lg12>						        
				<v-data-table :headers="headers" :search="search" :items="objManuPlists" class="elevation-1 linkTableMediumSmall" hide-actions style="font-size: 10px;" :rows-per-page-items="[1000]">
					<template slot="items" slot-scope="props">
						<td width="10%" ><v-switch label="" v-model="props.item.pl_active" checked="checked"></v-switch></td>      					
						<td width="45%" >{{ props.item.pl_name }}</td>      
						<td width="45%" >{{ props.item.pl_description }}</td>
						<!--<td >{{ props.item.pl_modified }}</td>-->
					</template>
				</v-data-table>
			</v-flex>			
			<div class="pl-4 pr-1 pb-4 buttonHolder">
				<div style="float: right">
					<v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
					<v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>
					<v-btn color="success"  v-if="!runAdd" @click.stop="fncUpdatePlists">Save</v-btn>
				</div>
			</div>
			<v-flex lg12 class="requiredMessage">
				&nbsp;
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex'; 	
	export default {
	  name: 'Settings',
	  data () {
			return {
				search: '',	
				roleActive: false,
				roleName: '',
				roleDescription: '',
				roleLevel: '',
				roleUserType: '',
				userType: [
					{ id: '1', text: 'Manufacturer User' },
					{ id: '2', text: 'Customer User' },
					{ id: '3', text: 'Spesific User' },
					{ id: '4', text: 'Public User' },
					{ id: '5', text: 'Non-registered User' }
				],
				headers: [         
					{ text: '', value: 'pl_id', width: '10%' },
                    { text: 'NAME', value: 'pl_name', width: '45%' },
                    { text: 'DESCRIPTION', value: 'pl_description', width: '45%' }
					//{ text: 'LAST MODIFIED', value: 'pl_modified' }					
				]	
			};
		},		
		methods: {
			fncHideModal () {
				this.$store.commit('hideModal');				
			},
            fncUpdatePlists() {	              
				this.$store.dispatch({
					type: 'fncUpdatePlists'					
				});
			}
		},
		computed: {
			...mapGetters([
				'objAuthorize',
				'globalModalParams',
				'runAdd',
				'objRoleEdit',
				'objRolePlists',
				'objManuPlists'
			])
		},
		watch: {
			objRoleEdit() {
				this.$store.dispatch({
					type: 'fncGetRolePlists',				
					roleId: this.objRoleEdit.id,
					userManufacturer: this.objAuthorize.manufacturer
				});
			}
		},
		created() {
			this.$store.dispatch({
				type: 'fncGetRolePlists',				
				roleId: this.objRoleEdit.id,
				userManufacturer: this.objAuthorize.manufacturer
			});
		}
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>